import styled from 'styled-components'

const SocialLinks = styled.ul`
  display: flex;
  gap: 1.5rem;
`

export default SocialLinks
